<script>
export default {
  name: 'app-tabs',
  props: {
    colsTabs: {
      type: Array,
      default() {
        return []
      }
    },
    logs: {
      type: Boolean,
      default: false
    },
    loadTab: {
      type: Number,
      default: null
    },
    shouldLoadFirstTab: {
      type: Boolean,
      default: false
    },
    sidebarTabs: {
      type: Boolean,
      default: false
    }
  },
  created() {
    if (this.loadTab && !this.shouldLoadFirstTab) {
      this.currentTab = this.loadTab
    }
  },
  data() {
    return {
      currentTab: 0,
      open: true
    }
  },
  watch: {
    currentTab(v) {
      this.$emit('appTabChanged', v)
    },
    shouldLoadFirstTab(v) {
      if (v === false && this.loadTab) {
        this.currentTab = this.loadTab
      }
    }
  },
  render(h) {
    const tabsInstance = this
    const slots = this.$slots.default

    if (slots) {
      const layout = slots.map((v, index) => {
        const tabDisabled = v.data.attrs['data-disabled'] !== undefined && v.data.attrs['data-disabled'] !== false

        const anchortag = h(
          'a',
          {
            class:
                  'r-tabs-anchor',
            attrs: {
              href: '#'
            },
            on: {
              click() {
                event.preventDefault()
              }
            }
          },
          [tabDisabled ? v.data.attrs['data-disabled-title'] : v.data.attrs.title]
        )

        const header = h(
          'li',
          {
            class: `
            r-tabs-tab
            ${tabsInstance.currentTab === index ? 'r-tabs-state-active' : 'r-tabs-state-default'}
            ${tabsInstance.open ? 'tab-open' : ''}
            ${tabDisabled ? 'disabled' : ''}
          `,
            on: {
              click() {
                if (tabDisabled) {
                  return
                }
                if (tabsInstance.currentTab === index) {
                  tabsInstance.open = !tabsInstance.open
                  return
                }
                tabsInstance.open = true
                tabsInstance.currentTab = index
              }
            }
          },
          [anchortag]
        )

        const arr = [header]

        if (window.innerWidth < 729) {
          arr.push(h('div', { class: 'app-tabs-content' }, v.children))
        }

        return arr
      })

      const result = [h('ul', { class: 'tabs r-tabs-nav' }, layout)]

      if (window.innerWidth >= 729) {
        result.push(h(
          'div',
          {
            class: `r-tabs-panel
                  r-tabs-state-active
                   ${this.colsTabs.includes(tabsInstance.currentTab) ? 'cols' : ''}
                   ${this.sidebarTabs ? 'tabs_content_left_inner_db' : 'tabs_content'}
                   ${this.logs ? 'logs' : ''}`,
            style: {
              display: 'block'
            }
          },
          slots[tabsInstance.currentTab].children
        ))
      }

      return h('div', { class: 'responsiveTabs r-tabs' }, result)
    }
  }
}
</script>
